var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#E2E8F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#94A3B8"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 36,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22 100 C 22 75, 35 62, 50 62 C 65 62, 78 75, 78 100 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlaceholder);
export default __webpack_public_path__ + "static/media/user-placeholder.6121418978985890f9f15f69f755ba43.svg";
export { ForwardRef as ReactComponent };